import Alert from '@mui/material/Alert';
import { useTranslation } from 'react-i18next';

export const ExcludeAnyAlert = () => {
  const { t } = useTranslation();

  return (
    <Alert severity="warning" data-test="cot-exclude-warning" sx={{ marginTop: 3, maxWidth: '640px' }}>
      {t('This is probably not what you want to do.')}
    </Alert>
  );
};
